import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { openExportDialog } from '../../tools/export-modal/export-modal.component';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_FORMATS } from '@huge-monorepo/shared/components';
import { Endpoints } from '@huge-monorepo/portal/config';
import { GenericService, ToolsService, UserRightsService } from '@huge-monorepo/portal/services';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'huge-monorepo-sim-latest-location-report',
  templateUrl: './sim-latest-location-report.component.html',
  styleUrl: './sim-latest-location-report.component.scss',
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class SimLatestLocationReportComponent {

  downloading = false;

  constructor(
    private endpoints: Endpoints,
    private auth: UserRightsService,
    private genericService: GenericService,
    private tools: ToolsService,
    private _location: Location,
    private dialogRef: MatDialog,
  ) { }

  exportReport() {
    openExportDialog(this.dialogRef, {
      endpoint: this.endpoints.GET_SIM_LATEST_LOCATION_REPORT,
      reqObj: {},
    });
  }

  cancel() {
    this._location.back();
  }
}
